import { Input } from 'antd'
import styled from 'styled-components'

const StyledFullWidthSearchInput = styled(Input.Search)`
  width: 100%;
`

export default StyledFullWidthSearchInput
